import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import CartItemsTable from './elements/CartItemsTable';
import ModalSelectCompany from './elements/ModalSelectCompany';
import CartItemsMobileList from './elements/CartItemsMobileList';
import ModalCreditLimit from './elements/ModalCreditLimit';
import styles from './Cart.scss';
import {openSignInPopup} from '../SignInPopup/redux/signInPopupActions';
import * as actions from './redux/cartActions';
import _ from 'lodash';
import Media from 'react-responsive';
import {formatPriceText as fpt} from 'src/logic/utils';
import {isAuthenticated} from 'src/logic/authHelpers';
import {declinationByNumber} from 'src/logic/utils';
import EmailInputBlock from './elements/EmailInputBlock';
import {Container, Button} from "../Common/reactstrap/lib";
import {setPaymentsDefault} from '../User/redux/userAction';

export class Cart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      setPaymentsDefault: false
    };
    this.checkoutCart = this.checkoutCart.bind(this);
    this.closeModalSelectCompany = this.closeModalSelectCompany.bind(this);
  }

  componentWillMount() {
    this.props.actions.getCart();

  }

  componentWillReceiveProps(props) {

  }

  componentDidUpdate() {

  }

  checkoutCart(e) {
    e.preventDefault();
    //todo: refactor getPaymentsDefault() getUserLegals() when do checkout
    let {paymentDefault, legals} = this.props.userData;
    if (!isAuthenticated()) {
      this.props.SignIn.openSignInPopup();
    } else {
      paymentDefault = legals.length > 0 ? paymentDefault : 0;
      if (paymentDefault >= 0) {
        this.props.actions.checkout(paymentDefault);
        this.setState({
          setPaymentsDefault: false
        });
      } else {
        this.setState({
          setPaymentsDefault: true
        });
      }

    }
  }

  closeModalSelectCompany() {
    this.props.setPaymentsDefault(-1);
    this.setState({
      setPaymentsDefault: false
    });
  }

  render() {
    //console.log(this);
    let cartItems = this.props.cartData.cartItems,
      thanks = this.props.cartData.thanks;
    if (!cartItems || !cartItems.length) {
      return (
        <div className={styles.root}>
          <div className="container">
            <p className={styles.emptyContent}>
              Ваша корзина сейчас пуста. Воспользуйтесь поиском, чтобы найти интересующие вас товары.
            </p>
          </div>

        </div>
      );
    }
    if (thanks === true) {
      return (
        <Container>
          <h2>
            Заказ успешно оформлен!
          </h2>
          <p className="m-b-2">В разделе <a href="/orders" className="link">Заказы</a> можно следить за его состоянием
          </p>

          <Button href="/">Продолжить покупки</Button>
        </Container>

      );
    }
    const sum = _.reduce(cartItems, (res, {price, quantity}) => res + +price * quantity, 0);

    return (
      <div className={styles.root}>
        <div className="container">
          <div className={styles.cartContent}>
            <h2 className={styles.cartPageHeader}>
              В корзине {cartItems.length} {declinationByNumber(cartItems.length, ['товар', 'товара', 'товаров'])}
              <Media query="(min-width: 1025px)"><span>
                {' '}на сумму {fpt(sum)} <span className="price">&#8381;</span></span></Media>
            </h2>
            <Media query="(min-width: 1025px)">
              <CartItemsTable
                items={cartItems}/>
            </Media>
            <Media query="(max-width: 1024px)">
              <CartItemsMobileList
                items={cartItems}/>
            </Media>
            <div className={styles.sumBlock}>
              Итого: {fpt(sum)} <span className="price">&#8381;</span>
            </div>
            <button
              className={styles.submitBtn}
              onClick={this.checkoutCart}>
              Оформить заказ
            </button>
          </div>
        </div>
        {isAuthenticated() && <ModalSelectCompany
          visible={this.state.setPaymentsDefault}
          submit={this.checkoutCart}
          close={this.closeModalSelectCompany}
          className="modal-small"
        />}
        <ModalCreditLimit
          isOpen={thanks === 'noFunds'}
          toggle={this.props.actions.checkoutReset}
        />
      </div>
    );
  }
}

Cart.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  cartData: state.cart2Reducer,
  userData: state.userReducer
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
  SignIn: bindActionCreators({openSignInPopup}, dispatch),
  setPaymentsDefault: bindActionCreators(setPaymentsDefault, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Cart);



/** WEBPACK FOOTER **
 ** ./src/components/Cart/index.jsx
 **/